export const filterNumberFromString = (value: string) => Number(value.replace(/[^0-9.-]+/g,""));
export const convertCurrencyFromCents = (amount: number) => amount / 100;